import { createAction, createSlice } from "@reduxjs/toolkit";

import { listFactory } from "store/listFactory";

import type {
  CashManagementProvider,
  CashManagementProviderCurrencies,
} from "../models/Provider";

const { slicePart } = listFactory<CashManagementProvider>(
  "cashManagementProvider"
);

const initialState = {
  ...slicePart.initialState,
  currencies: [] as CashManagementProviderCurrencies[],
  configurableProviders: [] as CashManagementProvider[],
};

export const slice = createSlice({
  ...slicePart,
  initialState,
  reducers: {
    setItem: slicePart.reducers.setItem,
    setList: slicePart.reducers.setList,
    setSupportedCurrencies: (state, action) => {
      const { data } = action.payload;

      state.currencies = data;
    },
    setConfigurableProviders: (state, action) => {
      const { data } = action.payload;

      state.configurableProviders = data.list;
    },
  },
});

export const { setItem, setSupportedCurrencies } = slice.actions;

export const fetchSupportedCurrencies = createAction(
  "fetchSupportedCurrencies"
);

export const selectSupportedCurrencies = (state: any) => {
  return state.cashManagementProvider.currencies;
};

export const cashManagementProviderReducer = slice.reducer;
